import { seoLinks, absoluteUrl, ogImage } from "@/lib/seo";
import { createFileRoute, Link } from "@tanstack/react-router";

import { FoodMenu } from "@/components/site/FoodMenu";
import { CtaBand, PageHero, Prose } from "@/components/site/Page";

const TITLE = "Matsedel och skolmat – Swedish International School";
const DESCRIPTION =
  "Så fungerar skolmaten hos oss i Estepona och Marbella: lagad lunch varje skoldag, specialkost efter behov och matsedel som publiceras löpande.";

export const Route = createFileRoute("/matsedel")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl("/matsedel") },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "sv_SE" },
      ...ogImage(),
    ],
    links: seoLinks("/matsedel"),
  }),
  component: MenuPage,
});

function MenuPage() {
  return (
    <>
      <PageHero
        eyebrow="Praktisk info"
        title="Matsedel"
        intro="Lunch serveras på skolan under ordinarie skoldagar. Matsedeln publiceras här på sidan – under lov publiceras ingen matsedel."
      />

      <FoodMenu locale="sv" />

      <Prose>
        <h2>Lunch varje skoldag</h2>
        <p>
          Lunch serveras på skolan under ordinarie skoldagar. Måltiderna varvar svenska och
          spanska rätter, med grönsaker, sallad och vegetariska alternativ som återkommande inslag.
        </p>


        <h2>Specialkost och allergier</h2>
        <p>
          Vi tar hänsyn till allergier, intoleranser och kost av religiösa eller etiska skäl. Ange
          behovet i{" "}
          <Link className="text-primary link-quiet" to="/ansokan">
            ansökan
          </Link>{" "}
          eller kontakta skolan, så går vi igenom det tillsammans med köket före skolstart.
        </p>

        <h2>Måltider under dagen</h2>
        <p>
          Lunchen är dagens huvudmåltid och äts tillsammans i lugn takt – det är också ett tillfälle
          att öva svenska i vardagliga samtal. De yngsta barnen äter med pedagoger vid bordet. Behöver
          ert barn frukt eller mellanmål utöver lunchen kommer vi överens om det i förväg.
        </p>

        <h2>Vem lagar maten</h2>
        <p>
          Maten lagas och levereras av ett kök som skolan samarbetar med. Matsedeln publiceras här
          på sidan så snart den är klar – under lov publiceras ingen matsedel. Rätterna varierar
          över veckorna och innehåller både svenska husmansrätter och lokala spanska inslag.
        </p>

        <h2>Frågor om maten</h2>
        <p>
          Har ni frågor om måltiderna, tiderna eller specialkost är ni välkomna att mejla{" "}
          <a className="text-primary link-quiet" href="mailto:info@sweintschool.com">
            info@sweintschool.com
          </a>
          .
        </p>
      </Prose>

      <div className="pb-16 sm:pb-24">
        <CtaBand />
      </div>
    </>
  );
}
